import { HttpClient } from "@angular/common/http";
import {
  TRANSLOCO_LOADER,
  Translation,
  TranslocoLoader,
  TRANSLOCO_CONFIG,
  translocoConfig,
  TranslocoModule,
  LangDefinition,
  DefaultTranspiler,
  TRANSLOCO_TRANSPILER,
  TRANSLOCO_MISSING_HANDLER,
  TranslocoMissingHandler,
  TranslocoMissingHandlerData,
  TRANSLOCO_INTERCEPTOR,
  TranslocoInterceptor,
  TRANSLOCO_FALLBACK_STRATEGY,
  DefaultFallbackStrategy,
} from "@ngneat/transloco";
import { Injectable, NgModule } from "@angular/core";

@Injectable()
class NoopMissingHandler implements TranslocoMissingHandler {
  handle(key: string, _config: TranslocoMissingHandlerData): string {
    return key;
  }
}

@Injectable()
class NoopInterceptor implements TranslocoInterceptor {
  preSaveTranslation(translation: Translation, _lang: string): Translation {
    return translation;
  }
  preSaveTranslationKey(_key: string, value: string, _lang: string): string {
    return value;
  }
}

import {
  DateFormatOptions,
  TranslocoLocaleModule,
  provideTranslocoLocale,
} from "@ngneat/transloco-locale";
import { environment } from "../../../environments/environment";

@Injectable({ providedIn: "root" })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private readonly http: HttpClient) {}

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}

const LANG_CONFIG: (LangDefinition & { locale: string })[] = [
  { id: "es", label: "Español", locale: "es-ES" },
  { id: "en", label: "English", locale: "en-US" },
  { id: "pt", label: "Português", locale: "pt-BR" },
];

export const GLOBAL_DATE_FORMAT: DateFormatOptions = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
};

const localeMapping = LANG_CONFIG.reduce(
  (acc, lang) => {
    acc[lang.id] = lang.locale;
    return acc;
  },
  {} as Record<string, string>,
);

@NgModule({
  exports: [TranslocoModule],
  imports: [TranslocoLocaleModule],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        availableLangs: LANG_CONFIG,
        defaultLang: localStorage.getItem('lang') || "es",
        reRenderOnLangChange: true,
        prodMode: environment.production,
      }),
    },
    { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader },
    { provide: TRANSLOCO_TRANSPILER, useClass: DefaultTranspiler },
    { provide: TRANSLOCO_MISSING_HANDLER, useClass: NoopMissingHandler },
    { provide: TRANSLOCO_INTERCEPTOR, useClass: NoopInterceptor },
    { provide: TRANSLOCO_FALLBACK_STRATEGY, useClass: DefaultFallbackStrategy },
    // Registers every token TranslocoLocaleService needs (default locale, currency,
    // transformers…); TranslocoLocaleModule alone only declares the pipes.
    provideTranslocoLocale({
      defaultLocale: "es-ES",
      langToLocaleMapping: localeMapping,
      localeConfig: {
        global: {
          date: GLOBAL_DATE_FORMAT,
        },
      },
    }),
  ],
})
export class TranslocoRootModule {}
